import styledComp from 'styled-components';
import { Colors } from '../../../../../constants';

export const Container = styledComp.div`
  width: 100%;
  position: relative;
  background-color: ${Colors.BLACK_100};
  padding-bottom: 56.25%;
`;

export const ImageWrapper = styledComp.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Image = styledComp.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;
